import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import LoginIcon from "@mui/icons-material/Login";
import RegisterIcon from "@mui/icons-material/AppRegistration";
import {Link, useNavigate} from "react-router-dom";
import {Form, useForm} from "react-hook-form"
import React, {useEffect, useState} from "react";
import {Alert} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import Cookies from 'js-cookie';
import axios from "axios";
import {LockReset} from "@mui/icons-material";

function encodeCredentials(username, password) {
    try {
        return btoa(`${username}:${password}`);
    } catch(error) {
    }
}
export default function Login() {
    const [alertSeverity, setAlertSeverity] = useState("info");
    const [alertMsg, setAlertMsg] = useState("Please login or subscribe for full access...");
    const {register, control} = useForm()
    const [emailAddress, setEmailAddress] = useState("");
    const [password, setPassword] = useState("");
    const [token, setToken] = useState("");
    const navigate = useNavigate();

    const loginWithToken = async (authToken) => {
        const encodedAuthToken = encodeURIComponent(authToken);
        try {
            const response = await fetch('../api/user/auth?token=' + encodedAuthToken, {
                method: 'GET'
            });

            if (response.ok) {
                const data = await response.json();
                navigate('/', {state: emailAddress, token});
            }
        } catch (error) {
        }
    };

    useEffect(() => {
        const authToken = Cookies.get('auth');
        const emailAddress = Cookies.get('email');
        if (authToken && emailAddress) {
            setToken(authToken);
            setEmailAddress(emailAddress);
            loginWithToken(authToken, emailAddress);
        }
    }, []);

    const handleSubmit = async () => {
        const encodedCredentials = encodeCredentials(emailAddress, password);
        const formData = new URLSearchParams();
        formData.append('token', encodedCredentials);

        try {
            const response = await axios.post('./api/user/login', formData, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
            setAlertMsg("User authenticated, authorizing access...");
            setAlertSeverity("success");
            const expirationTime = new Date(new Date().getTime() + (60000 * 60 * 168));
            const passHash = response.data.passHash;
            Cookies.set('auth', passHash, { expires: expirationTime });
            Cookies.set('email', emailAddress, { expires: expirationTime });
            Cookies.set('woven_session', 'post-login', { expires: expirationTime });
            Cookies.set("analytics_section", "offers");
            if(response.data.enabled) {
                navigate("/");
            } else {
                navigate("/profile");
            }
        } catch (error) {
            setAlertMsg("The email address or password are invalid:");
            setAlertSeverity("error");
        }
    };

    return (

        <div className="Section">
            <div className="SectionLtr">

              <span className='SectionBoxAutoHeight'>
                  <span className="SectionHeadingIcon"><PersonIcon sx={{ fontSize: 43 }}/></span>
                      <span className="SectionHeading">ANALYTICS</span>
                      <span className="SectionSubHeading">LOGIN</span>
                  <div className="_div_line_dual_grad"></div>
                <Form onSubmit={handleSubmit} control={control}>
                  <div className="_inputSection">
                      <div className="Alert">
                          <Alert id="alert_view" severity={alertSeverity} className="Alert">{alertMsg}</Alert>
                      </div>
                      <div className="_input_title"></div>
                      <div className="_inputLine">
                          <TextField type="email" id="email"
                                     label="Email Address"  size="small"
                                     onChange={e => setEmailAddress(e.target.value)}/>
                      </div>

                      <div className="_inputLine">
                          <TextField id="pass_hash"
                                     label="Password" variant="outlined" size="small"
                                     type="password"
                                     onChange={e => setPassword(e.target.value)}/>
                      </div>

                  </div>

                  <div className="_button_bar">
                      <span className="_button_holder">
                          <LoginButton/>
                      </span>

                       <span className="_button_holder">
                           <Link to="/register"><RegisterButton/></Link>
                      </span>
                  </div>

                    <div className="_div_line_dual_grad"></div>
                  <div className="_button_bar">
                      <span className="_button_holder">
                          <Link to="/resetPass"><ResetButton/></Link>
                      </span>
                  </div>
                </Form>
              </span>
            </div>
        </div>
    );
}


function LoginButton() {
    return (
        <Button type="submit" variant="contained" size="medium" startIcon={<LoginIcon/>}>
            Login
        </Button>
    );
}

function RegisterButton() {

    return (
        <Button variant="outlined" startIcon={< RegisterIcon/>}>
            Subscribe...
        </Button>
    );
}

function ResetButton() {

    return (
        <Button color="primary" variant="text" size="medium" startIcon={<LockReset/>}>
            Reset password...
        </Button>
    );
}

